import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { InterfaceContextAPI } from '@contexts/interfaceContext';
import '@fontsource/rubik/400.css';
import '@fontsource/rubik/500.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import { AuthProvider } from '@contexts/authContext';

// Chromium fires this when ResizeObserver runs in the same frame as a layout change
// (common with MUI, tables, route transitions). It is harmless but trips the CRA error overlay.
window.addEventListener(
  'error',
  (e) => {
    if (
      typeof e.message === 'string' &&
      e.message.includes('ResizeObserver loop')
    ) {
      e.stopImmediatePropagation();
    }
  },
  true
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <InterfaceContextAPI>
      <AuthProvider>
        <App />
      </AuthProvider>
    </InterfaceContextAPI>
  </BrowserRouter>
);
